var _path, _path2, _path3, _path4, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarSeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 160",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.879,89.463A8.855,8.855,0,0,1,51.642,92.6a5.768,5.768,0,0,1,.447.567,7.392,7.392,0,0,1,.532.851,9.785,9.785,0,0,0,1.436-1.427,9.938,9.938,0,0,0,1.117-1.65A12.549,12.549,0,0,0,56.6,85.983a16.129,16.129,0,0,0-2.664-10.158,86.347,86.347,0,0,1-5.474-10.1,77.1,77.1,0,0,1-5.852-18.6c-.206-1.134-.43-2.225-.671-3.257a8.1,8.1,0,0,0-7.9-6.307c-.37,0-.7.034-1.066.068l-.137.009a9.619,9.619,0,0,0-1.055.226V34.364a7.919,7.919,0,0,0,7.732-6.87l1.263-9.548a7.918,7.918,0,0,0-6.8-8.877A8.058,8.058,0,0,0,32.933,9,7.927,7.927,0,0,0,25.1,15.875l-1.264,9.548A7.913,7.913,0,0,0,30.066,34.2v4.321a9.4,9.4,0,0,0-4.9,11.3L38.27,92.411A8.757,8.757,0,0,1,44.879,89.463Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.046,98.349a7.168,7.168,0,0,0-14.335,0,7.168,7.168,0,0,0,14.335,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.021,94.559a10.022,10.022,0,0,0-11.258-8.636L57.211,90.666a11.711,11.711,0,0,1-.525,1.1,12.218,12.218,0,0,1-1.306,1.925A11.8,11.8,0,0,1,53.7,95.359l-.369.292a8.623,8.623,0,0,1,.429,2.7,8.9,8.9,0,0,1-8.885,8.886c-.293,0-.576-.017-.86-.043v3.644H97.61l.206-.138C102.818,107.467,104.957,101.881,104.021,94.559Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.019,112.555v1.194A5.256,5.256,0,0,0,49.27,119h43.7a5.254,5.254,0,0,0,5.242-5.251V112.5l-.077.052Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 143,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by DinosoftLabs")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 148,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSeat);
export default __webpack_public_path__ + "static/media/car_seat.60c2d5a0881260a3dfdf989889e210fb.svg";
export { ForwardRef as ReactComponent };